import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import dayjs from "dayjs"

import {
	getBinderNumber,
	getClaimFact,
	formatDate,
	getTransactionsFact
} from "./helpers"

const header = [
	[
		"Unique Market Reference",
		"Agreement Number",
		"Year of Account",
		"Accounting class",
		"Accounting sub-class",
		"Direct or Type of Reinsurance",
		"Certificate Reference",
		"Claim Reference",
		"Claimant Name",
		"Trade Occupation",
		"Type of Vehicle",
		"Number of Vessels",
		"Location of Loss Country",
		"Loss Description",
		"Date of Loss",
		"Date First Advised/Notification Date",
		"Nature of Claim",
		"Claim Status",
		"Paid This Month Indemnity Original Currency",
		"Paid This Month Indemnity",
		"Paid This Month Fees Original Currency",
		"Paid this Month Fees",
		"Outstanding Claim Indemnity Original Currency",
		"Outstanding Claim Indemnity",
		"Outstanding Claim Fees Original Currency",
		"Outstanding Claim Fees",
		"Management Expenses Currency",
		"Management Expenses",
		"Notes",
		"Binder Establishment Date"
	]
]

/****************** Helper Functions ******************/
const getBinderYearOfAccount = policy => {
	const startDate = policy?.associatedContracts?.[0]?.contract?.startDate
	return dayjs(startDate).format("YYYY")
}
const getClaimFactDate = (key, claim) => {
	const date = getClaimFact(key, "dateValue", claim)
	return dayjs(date).format("YYYY/MM/DD")
}

/****************** Define Rows ******************/
const rows = payload => {
	let output = []
	payload?.reverse()?.map(claim => {
		let policy = claim?.policy
		output.push([
			getBinderNumber(policy),
			"",
			getBinderYearOfAccount(policy),
			"",
			"",
			"",
			policy?.issuerNumber,
			claim?.issuerNumber,
			policy?.contractHolder?.name,
			"",
			"",
			"",
			getClaimFact("lossCountry", "stringValue", claim),
			getClaimFact("causeOfLoss", "stringValue", claim),
			getClaimFactDate("lossDate", claim),
			getClaimFactDate("reportedDate", claim),
			"",
			claim?.status,
			claim?.status === "APPROVED"
				? claim?.transactions?.[0]?.currencyCode
				: "",
			claim?.status === "APPROVED" ? claim?.transactions?.[0]?.amount : "",
			"",
			"",
			claim?.status === "PROCESSING"
				? claim?.transactions?.[0]?.currencyCode
				: "",
			claim?.status === "PROCESSING" ? claim?.transactions?.[0]?.amount : 0,
			"",
			"",
			"",
			"",
			getTransactionsFact("remark", "stringValue", claim?.transactions?.[0]),
			formatDate(claim?.policy?.associatedContracts?.[0]?.contract?.startDate)
		])
	})

	return output
}

/****************** Function for fetching ******************/
const fetchClaims = async filterPayload => {
	const dateFrom = filterPayload?.createdAt?.after
		? dayjs(filterPayload?.createdAt?.after).format()
		: null
	const dateTo = filterPayload?.createdAt?.before
		? dayjs(filterPayload?.createdAt?.before)
				.add(1, "day")
				.format()
		: null

	const query = gql`
		query fetchClaims($claimWhere: claimWhereInput) {
			claims(where: $claimWhere) {
				list {
					createdAt
					issuerNumber
					status
					totalValues {
						approvedAmount
						approvedCurrency
						billedAmount
						billedCurrency
					}
					benefitClaims {
						remark
					}
					policy {
						associatedContracts {
							contract {
								facts {
									type
									value {
										stringValue
										dateValue
									}
								}
								startDate
							}
						}
						issuerNumber
						facts {
							type
							value {
								stringValue
								dateValue
							}
						}
						contractHolder {
							name
						}
					}
					issuerNumber
					facts {
						type
						value {
							stringValue
							dateValue
						}
					}
					status
					transactions {
						facts {
							type
							value {
								stringValue
								numberValue
								dateValue
							}
						}
						amount
						currencyCode
						dateTime
					}
				}
			}
		}
	`
	const variables = {
		claimWhere: { createdAt_gt: dateFrom, createdAt_lt: dateTo }
	}

	const res = await api({ query, variables })
	//TODO: error handling
	return res?.data?.claims?.list
}

/****************** Export ******************/
export default async filterPayload => {
	const fetchedData = await fetchClaims(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header?.[0]?.map(item => ({ wpx: 200 }))
	return { workSheetData, workSheetColumns }
}
